import { useQuery } from "@tanstack/react-query";
import { getAllCalendarEvents } from "./calander";

export const useCalendarEvents = () => {
  return useQuery({
    queryKey: ["calendar-events"],
    queryFn: () => getAllCalendarEvents(),
    staleTime: 5 * 60 * 1000,
  });
};
